import { createContext, createRef, useContext } from 'react';

const VHWebModalContext = createContext();
const vhWebModalRef = createRef();

export const VHWebModalContextProvider = (props) => {
  return (
    <VHWebModalContext.Provider value={vhWebModalRef}>
      {props.children}
    </VHWebModalContext.Provider>
  );
};

export const useVHWebModalContext = () => useContext(VHWebModalContext);

export default VHWebModalContextProvider;
